import './ButtonRenderer.scss';
import type { IntlKey } from 'locales';
import { FC, MouseEventHandler, useCallback } from 'react';
import { useIntl } from 'react-intl';

import type { AddToOrderBasketButtonProps } from './AddToOrderBasketButton.connect';
import { connectAddToOrderBasketButton } from './AddToOrderBasketButton.connect';

export const Component: FC<AddToOrderBasketButtonProps> = ({ data, onAdd }) => {
  const { formatMessage } = useIntl();
  const onClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    event => {
      event.preventDefault();
      onAdd(data, formatMessage({ id: `quote.products.${data.productSubType}` as IntlKey }));
    },
    [data, formatMessage, onAdd],
  );
  return (
    <button className="btn btn-flat-primary" disabled={!data.canAddToOrdersBasket} onClick={onClick}>
      <em className="icon icon-sm">add</em>
    </button>
  );
};

export const AddToOrderBasketButton = connectAddToOrderBasketButton(Component);
